import React from 'react'
import { Mask } from 'react-weui'
import shuangqianMedalImg from '../../images/medals/shuangqian22.png'
import { WKVisible } from '../../components/wk'
import { browserHistory } from 'react-router'
import shuangqian2Img from '../../images/medals/shuangqian2.png'
import closeImg from '../../images/close-grey.png'
import showCertificateBtnImg from '../../images/medals/show-certificate-btn.png'


class MedalP extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isShowMedalModal: false,
            selectedType: '',
        }
    }
    onClickMedal (e, type) {
        e.stopPropagation()
        if (this.props.onClickMedal) {
            this.props.onClickMedal(type)
        }
        this.setState({ isShowMedalModal: true, selectedType: type })
    }
    onClickCertificate () {
        if (this.props.onClickCertificate) {
            this.props.onClickCertificate()
        }
        location.assign(`/specials/activity/certificate?type=${this.state.selectedType}&id=${this.props.liveroom.id}`)
    }
    render() {
        const { isShowMedalModal } = this.state
        return (
            <div className="wk-medals-wrap">
                <div className="medal-wrap">
                    {
                        this.props.medals.map(item => {
                            return (
                                <div 
                                    key={item}
                                    onClick={e => this.onClickMedal(e, item)} 
                                    className={`medal medal-${item}`}
                                >
                                    {
                                        item === 'tt_achieve' && (
                                            <img 
                                                src={shuangqianMedalImg} 
                                                alt={item}
                                            />
                                        )
                                    }
                                </div>
                            )
                        })
                    }
                </div>
                {
                    isShowMedalModal && (
                        <div className="wk-medal-modal">
                            <Mask onClick={e => this.setState({ isShowMedalModal: false })} />
                            <div className="content">
                                <div className="close" onClick={e => this.setState({ isShowMedalModal: false })}>
                                    <img src={closeImg} className='wk-pointer-hand' alt='' />
                                </div>
                                <WKVisible show={this.state.selectedType === 'tt_achieve'}>
                                    <div className="img">
                                        <img src={shuangqian2Img} alt="" />
                                    </div>
                                    <div className="title">
                                        最具潜力直播间
                                    </div>
                                    <div className="desc">
                                        荔枝微课签约直播间，战略合作伙伴
                                    </div>
                                    <WKVisible create={this.props.isShowBtn}>
                                        <button 
                                            className='show-certificate-btn' 
                                            onClick={e => this.onClickCertificate()}
                                        >
                                            <img src={showCertificateBtnImg} alt='' />
                                        </button>
                                    </WKVisible>
                                </WKVisible>
                            </div>
                        </div>
                    )
                }
                    
            </div>
        )
    }
}


export default MedalP


// WEBPACK FOOTER //
// ./src/components/medal/MedalP.js